export const ChatTypes = {
    GET_CHAT_INDEX: "GET_CHAT_INDEX",
    CLEAR_CHAT_INDEX: "CLEAR_CHAT_INDEX",
    GET_MESSAGE_LIST: "GET_MESSAGE_LIST",
    UPDATE_MESSAGE_LIST: "UPDATE_MESSAGE_LIST",
    CLEAR_MESSAGE_LIST: "CLEAR_MESSAGE_LIST",

}